module.exports = __webpack_public_path__ + "static/img/wqimage15.3e1b5298.jpg";